export const EDITABLE_SECTION_NAME = "✏️ Custom Reports"
